// English language pack

export default {
  // --- Cards ---
  'card.damage.label': 'Precise Strike',
  'card.damage.desc': '+{value} damage',
  'card.maxHp.label': 'Tough Skull',
  'card.maxHp.desc': '+{value} max HP and healing',
  'card.speed.label': 'Light Step',
  'card.speed.desc': '+{speed} speed, −{cd}% attack cooldown',
  'card.attackRange.label': 'Long Arm',
  'card.attackRange.desc': '+{value} attack range',
  'card.cooldown.label': 'Fast Swing',
  'card.cooldown.desc': '−{value}% attack cooldown',
  'card.lifesteal.label': 'Vampirism',
  'card.lifesteal.desc': '+{value}% HP from damage dealt',
  'card.magnet.label': 'Greedy Hands',
  'card.magnet.desc': '+{value}% magnet range',
  'card.thorns.label': 'Thorns',
  'card.thorns.desc': 'Melee attackers take {value}% damage back',
  'card.regen.label': 'Second Wind',
  'card.regen.desc': '+{value} HP/sec regeneration',
  'card.dashCooldown.label': 'Quick Feet',
  'card.dashCooldown.desc': '−{cd}% dash cooldown, +{iframe}s i-frame',
  'card.draftSize.label': 'Plan Ahead',
  'card.draftSize.desc': '+1 card in shop offer (max 5)',
  'card.fortify.label': 'Bloodthirst',
  'card.fortify.desc': '+{value} HP per guard kill',
  'card.armorBreak.label': "Smith's Son",
  'card.armorBreak.desc': 'Attacks ignore armor',
  'card.cleave.label': 'Lumberjack',
  'card.cleave.desc': '+{value}% damage to other enemies in attack arc',
  'card.doubleStrike.label': 'Double Strike',
  'card.doubleStrike.desc': 'Every {n}th swing — cooldown ×0.5',
  'card.doubleStrike.descFull': 'All rhythm triggers active',
  'card.crit.label': 'Born Lucky',
  'card.crit.desc': '{value}% chance to deal double damage',
  'card.phantom.label': 'Wind-Born',
  'card.phantom.desc': 'Post-dash invulnerability, up to 60% of its cooldown',
  'card.glassCannon.label': 'Berserk',
  'card.glassCannon.desc': '+{dmg} damage, −{hp} max HP',
  'card.wideArc.label': 'Whirlwind',
  'card.wideArc.desc': 'Attack hits all around',
  'card.rebirth.label': 'Rebirth',
  'card.rebirth.desc': 'Die. Be born again. Reset to wave 1; score persists, guards get faster.',
  'cutscene.rebirth.title': 'REBIRTH',
  'cutscene.rebirth.aphorism': 'Die. Be born again.',
  'cutscene.rebirth.tail': 'wave {wave} → 1',
  'cutscene.rebirth.subtitle': 'wave {wave} → 1',

  // --- Caravan types ---
  'caravan.donkey': 'Donkey',
  'caravan.wagon': 'Wagon',
  'caravan.royal': 'Carriage',

  // --- Main menu ---
  'menu.title': 'CARAVANS',
  'menu.subtitle': 'rob the caravans!',
  'menu.record': 'Record: {score}  •  Wave: {wave}',
  'menu.controls1': 'WASD / arrows - move',
  'menu.controls2': 'Space / RMB - attack   •   LMB - move   •   Shift - dash   •   Q - super strike   •   E - shop',
  'menu.controls3': 'Esc - pause   •   M - sound   •   F - fullscreen   •   Caps Lock - auto-attack',
  'menu.start': '[ Enter / click — start ]',
  'menu.touchControls1': 'Touch and drag - move',
  'menu.touchControls2': '⚔ - attack (drag left onto the lock for auto-attack)   •   ⚡ - dash   •   💥 - super strike',
  'menu.touchStart': '[ tap to start ]',
  'menu.updateAvailable': '↻ New version available ({short}) — tap to reload',

  // --- HUD ---
  'hud.wave': 'Wave: {wave}',
  'hud.waveBoss': 'Wave: {wave} [BOSS]',
  'hud.score': 'Score: {score}',
  'hud.caravansGuards': 'Caravans: {caravans}  Guards: {guards}',

  // --- Shop ---
  'shop.titleShop': 'MERCHANT',
  'shop.titleInterwave': 'PICK A CARD',
  'shop.gold': 'Gold: {gold}',
  'shop.soldOut': 'SOLD OUT',
  'shop.soldOutHint': 'Come back next wave',
  'shop.exit': 'Exit shop',
  'shop.skip': 'Skip >',
  'shop.reroll': '⟳ Reroll ({cost})',
  'shop.stats': 'Stats:',
  'shop.statDamage': 'Damage: {value}',
  'shop.statHp': 'HP: {hp}/{maxHp}',
  'shop.statSpeed': 'Speed: {value}',
  'shop.statRange': 'Range: {value}',
  'shop.statAtkSpeed': 'Atk Speed: {value}/s',
  'shop.statVamp': 'Vamp: {value}%',
  'shop.statThorns': 'Thorns: {value}%',
  'shop.statMagnet': 'Magnet: x{value}',
  'shop.statWideArc': 'Whirlwind',
  'shop.interact': '[E] TRADE',
  'shop.interactTouch': 'TAP TO TRADE',

  // --- Wave end summary ---
  'waveEnd.title': 'WAVE {wave} CLEARED',
  'waveEnd.caravans': 'Caravans robbed: {robbed} / {total}',
  'waveEnd.guards': 'Guards slain: {count}',
  'waveEnd.damage': 'Damage taken: {value}',
  'waveEnd.gold': 'Gold earned: {value}',
  'waveEnd.flawless': 'FLAWLESS! +{value}',
  'waveEnd.continue': '[ click / Enter — continue ]',

  // --- Pause ---
  'pause.title': 'PAUSED',
  'pause.resume': 'Esc / P - resume',
  'pause.mute': 'M - sound',

  // --- Game over ---
  'gameover.title': 'GAME OVER',
  'gameover.diedOnWave': 'Died on wave: {wave}',
  'gameover.caravansRobbed': 'Caravans robbed: {count}',
  'gameover.score': 'Score: {score}',
  'gameover.newRecord': 'NEW RECORD!',
  'gameover.record': 'Record: {score} (wave {wave})',
  'gameover.continue': '[ Enter / click — continue ]',
  'gameover.nameTitle': 'YOUR NICKNAME',
  'gameover.namePlaceholder': 'not your real name',
  'gameover.nameOk': 'DONE',
  'gameover.nameSkip': 'skip',
  'gameover.communityCta': '💬 Join Telegram chat',
  'menu.privacy': 'Privacy',
  'menu.telemetryOn': 'Stats: on',
  'menu.telemetryOff': 'Stats: off',
  'menu.leaderboard': 'LEADERS',

  // --- AI overlay ---
  'ai.hints': '1-6: speed  Esc: pause  M: sound',

  // --- Relics (collectible meta-progression) ---
  'relic.reflexes.label': 'Good Reflexes',
  'relic.reflexes.desc': 'Auto-attack when an enemy is in range',
  'relic.coinSense.label': 'Nose for Loot',
  'relic.coinSense.desc': 'Off-screen coins shown as gold arrows',
  'relic.engineerEye.label': 'Engineer\'s Eye',
  'relic.engineerEye.desc': 'Show guard attack range + HP numbers',
  'relic.timeSlow.label': 'Time Slowdown',
  'relic.timeSlow.desc': 'Time crawls when enemies are close',
  'relic.timeFast.label': 'Time Speedup',
  'relic.timeFast.desc': 'Time rushes when no enemies are near',
  'relic.miserGrip.label': 'Miser\'s Grip',
  'relic.miserGrip.desc': 'After the wave is cleared, every coin flies home',
  'relic.bloodFog.label': 'Blood Fog',
  'relic.bloodFog.desc': 'Screen edges redden when HP runs low',
  'relic.unlocked.title': 'NEW RELIC UNLOCKED',
  'relic.unlocked.hint': 'Toggle in the main menu',
  'menu.relics': 'Relics:',

  // --- Novice onboarding (v1.3.0) ---
  'onboarding.mercyHeal': 'Fully healed',

  // --- Guard drops ("ништяки" — drop from killed guards) ---
  'pickup.medkit.label': 'Medkit',
  'pickup.purse.label': 'Coin Purse',
  'pickup.rage.label': 'Battle Cry',
  'pickup.frenzy.label': 'Quick Hands',
  'pickup.guard.label': 'Nerve',
  'pickup.spice.label': 'Spice Sack',
  'pickup.horse.label': 'Horse',

  // --- Player statuses ---
  'status.stuck': 'STUCK!',
  'status.autoAttackOn': 'AUTO-ATTACK ON',
  'status.autoAttackOff': 'AUTO-ATTACK OFF',
  'status.superReady': 'SUPER STRIKE READY!',
  'status.horseMounted': 'HORSE!',
  'status.horseLost': 'THE HORSE RAN OFF',
};
